export function btoa(str: string) {
  return window.btoa(str);
}
